// Utils.js
import Parse from "../../api/ApiConfig";

/* eslint-disable */
export const getLeasorName = (data) => {
	if (data?.admin || data?.productId?.admin) {
		return data?.admin || data?.productId?.admin;
	} else return "---";
};

export const getUserName = (data) => {
	if (data?.userId?.firstName) {
		return data?.userId?.firstName + " " + data?.userId?.lastName;
	} else if (data?.user?.firstName) {
		return data?.user?.firstName + " " + data?.user?.lastName;
	} else return "---";
};

/**********************
	API functions
**********************/
const requestHeaders = {
	"X-Parse-Application-Id": "FortCore",
};

export const fetchChartData = async () => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/getAfInfo";
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			headers: requestHeaders,
		});

		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

// Fetch Apprenticeship table data (ongoing, submitted, completed, created_assets, savings)
export const fetchFundedData = async (filter) => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/getFundedRequests";

		const response = await fetch(url, {
			method: "POST",
			headers: requestHeaders,
			body: JSON.stringify({ queryType: filter }),
		});
		const data = await response.json();

		const newData = data.result?.sort(
			(leaseOne, leaseTwo) =>
				new Date(leaseTwo?.createdAt)?.getTime() - new Date(leaseOne?.createdAt)?.getTime()
		);
		return data ? newData : [];
	} catch (error) {
		throw error;
	}
};
export const fetchTableData = async (category, filter) => {
	try {
		if (category) {
			let url = process.env.REACT_APP_SERVER_URL + "/functions/";
			// update url based on category
			switch (category) {
				case "ongoing":
					url += "ongoingAF";
					break;
				case "submitted":
					url += "submittedAF";
					break;
				case "completed":
					url += "completedAF";
					break;
				case "created_assets":
					url += "getCreatedAF";
					break;
				case "savings":
					url += "getAfSavings";
					break;
				case "inactive":
					url += "getInactiveRequests";
					// url += "getCreatedAF";
					break;
				case "active":
					url += "getActiveRequests";
					break;
				case "funded":
					// 	console.log(2, category);
					url += "getFundedRequests";
				default:
					return [];
			}

			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				headers: requestHeaders,
				body: JSON.stringify({ queryType: filter }),
			});
			const data = await response.json();

			const newData = data.result?.sort(
				(leaseOne, leaseTwo) =>
					new Date(leaseTwo?.createdAt)?.getTime() - new Date(leaseOne?.createdAt)?.getTime()
			);
			console.log(category, filter, data.result);

			return data ? newData : [];
			// return data ? data.result : [];
		} else return null;
	} catch (error) {
		console.log(error);
		return null;
	}
};

// Fetch single Apprenticeship object
export const fetchAFobject = async (objectId) => {
	try {
		if (objectId) {
			const url = process.env.REACT_APP_SERVER_URL + "/functions/viewAF";
			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify({ objectId: objectId }),
				headers: requestHeaders,
			});
			const data = await response.json();
			console.log(objectId, data);
			return !data.error ? data : { error: data.error };
		} else {
			return { error: "Apprenticeship ID not specified" };
		}
	} catch (error) {
		console.log(error);
		return null;
	}
};

// Fetch single Created Asset object
export const fetchInvestorAssetObject = async (assetId) => {
	try {
		if (assetId) {
			const url = process.env.REACT_APP_SERVER_URL + "/functions/getAFById";
			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify({ objectId: assetId }),
				headers: requestHeaders,
			});
			const data = await response.json();
			// console.log(assetId, data);
			return !data.error ? data : { error: data.error };
		} else {
			return { error: "Asset ID not specified" };
		}
	} catch (error) {
		console.log(error);
		return null;
	}
};

// Fetch single Savings object
export const fetchSavingsObject = async (objectId) => {
	try {
		if (objectId) {
			const url = process.env.REACT_APP_SERVER_URL + "/functions/getSavingById";
			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify({ objectId }),
				headers: requestHeaders,
			});
			const data = await response.json();
			console.log(objectId, data);
			return !data.error ? data : { error: data.error };
		} else {
			return { error: "Object ID not specified" };
		}
	} catch (error) {
		console.log(error);
		return null;
	}
};

export const formatDurationForProgramSavings = (duration) => {
	const length = duration?.split(" ")?.at(0);
	const time = duration?.split(" ")?.at(1);

	if (time?.toLowerCase().includes("week")) {
		if (length < 4) {
			return 1;
		} else {
			return Math.ceil(length / 4);
		}
	}
	if (time?.toLowerCase().includes("month")) {
		return length;
	}
	if (time?.toLowerCase().includes("year")) {
		return 12 * length;
	}
};

export const calculateProgramSavings = (amountRepayable, duration) => {
	const amount = Number(amountRepayable?.replaceAll(",", "")) || 0;

	const getTime = formatDurationForProgramSavings(duration);

	const addedFee = amount < 100 ? 0.02 : 0.05;

	const savings = amount / getTime + addedFee || 0;

	const formattedSavings = savings?.toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	return formattedSavings;
};

export const businessTypes = [
	{
		value: "restaurant",
		label: "Restaurant",
	},
	{
		value: "retail",
		label: "Retail Store",
	},
	{
		value: "technology",
		label: "Technology Company",
	},
	{
		value: "consulting",
		label: "Consulting Firm",
	},
	{
		value: "construction",
		label: "Construction Company",
	},
	{
		value: "healthcare",
		label: "Healthcare Provider",
	},
	{
		value: "e-commerce",
		label: "E-commerce Business",
	},
	{
		value: "manufacturing",
		label: "Manufacturing Company",
	},
	{
		value: "transportation",
		label: "Transportation Service",
	},
	{
		value: "hospitality",
		label: "Hospitality Industry",
	},
	{
		value: "finance",
		label: "Financial Institution",
	},
	{
		value: "education",
		label: "Education Institution",
	},
	{
		value: "media",
		label: "Media and Entertainment",
	},
	{
		value: "agriculture",
		label: "Agriculture Business",
	},
	{
		value: "fashion",
		label: "Fashion Retailer",
	},
	{
		value: "automotive",
		label: "Automotive Industry",
	},
];

export const DurationOptions = [
	"1 week",
	"2 weeks",
	"3 weeks",
	"1 month",
	"2 months",
	"3 months",
	"4 months",
	"5 months",
	"6 months",
	"7 months",
	"8 months",
	"9 months",
	"10 months",
	"11 months",
	"12 months",
	"18 months",
	"2 years",
	"3 years",
	"4 years",
	"5 years",
	"6 years",
	"7 years",
	"8 years",
	"9 years",
	"10 years",
];

export const adminCreateQuickFinanceReq = async (dataToSave) => {
	try {
		const AFBusinessCreate = Parse.Object.extend("AFBusinessCreate");
		const object = new AFBusinessCreate();
		const response = await object.save(dataToSave);

		return response;
	} catch (error) {
		console.log(error);
		if (error?.message?.includes("Unable to connect to the Parse API")) {
			throw "Oops! You are not conected to the internet";
		} else {
			throw "Failed to update request status";
		}
	}
};

export const updateAdminCreatedRequest = async (requestId, data) => {
	try {
		const query = new Parse.Query("AFBusinessCreate");
		const object = await query.get(requestId);
		const updatedObject = await object.save(data);

		return updatedObject?.toJSON();
	} catch (error) {
		console.log(error);
		console.log(error);
		if (error?.message?.includes("Unable to connect to the Parse API")) {
			throw "Oops! You are not conected to the internet";
		} else {
			throw "Failed to update request status";
		}
	}
};

export const handleAdminUpdateRequest = async (requestId, data) => {
	try {
		const query = new Parse.Query("ApprenticeshipFinance");
		const object = await query.get(requestId);
		const updatedObject = await object.save(data);

		return updatedObject;
	} catch (error) {
		console.log(error);
		if (error?.message === "Failed to fetch") {
			throw "Oops. You are not connected to the internet.";
		} else if (error?.message?.includes("Unable to connect to the Parse API")) {
			throw "Oops! You are not conected to the internet";
		} else {
			throw "Failed to update request status";
		}
	}
};

export const onAdminUpdatesRequestStatus = async (assetId, assetData, newData) => {
	console.log(assetId, assetData, newData);
	try {
		const queryOne = new Parse.Query("AFBusinessCreate");
		const objectOne = await queryOne.get(assetId);
		const updatedObjectOne = await objectOne.save(assetData);

		console.log(updatedObjectOne);

		// Create a query to fetch objects based on your criteria
		const query = new Parse.Query("ApprenticeshipFinance");
		query.containedIn(
			"objectId",
			newData.map((obj) => obj?.id)
		);

		const objects = await query.find();

		const objectMap = new Map();
		objects.forEach((parseObject) => {
			objectMap.set(parseObject.id, parseObject);
		});

		const updatedObjects = newData.map(async (newDataItem) => {
			const objectId = newDataItem?.id;
			const parseObject = objectMap.get(objectId);
			if (parseObject) {
				// Update parseObject with all properties from newDataItem
				Object.keys(newDataItem).forEach((key) => {
					parseObject.set(key, newDataItem[key]);
				});
				// Save the updated parseObject
				return await parseObject.save();
			} else {
				// Handle the case where the object with the provided objectId is not found
				console.log(`Object with objectId ${objectId} not found.`);
				return null;
			}
		});

		// Wait for all updates to complete
		const dataTwo = await Promise.all(updatedObjects);

		return {
			investorFinance: updatedObjectOne?.toJSON(),
			apprentinceReqs: dataTwo,
		};
	} catch (error) {
		console.log(error);
		if (error?.message?.includes("Unable to connect to the Parse API")) {
			throw "Oops! You are not conected to the internet";
		} else {
			throw "Failed to update request status";
		}
	}
};
